import { render, staticRenderFns } from "./CampaignManager.vue?vue&type=template&id=530f22c1&scoped=true&"
import script from "./CampaignManager.vue?vue&type=script&lang=js&"
export * from "./CampaignManager.vue?vue&type=script&lang=js&"
import style0 from "./CampaignManager.vue?vue&type=style&index=0&id=530f22c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530f22c1",
  null
  
)

export default component.exports